// extracted by mini-css-extract-plugin
module.exports = {"container":"Input_container__FNiXU","date":"Input_date__2zIdv","time":"Input_time__1ohX0"};